import {
  convertDateToISOFormat,
  getRandomDate,
  quizFormatDate,
} from "@helper/utils";
import logger from "@src/logger/Logger";

export interface PuzzleData {
  [key: string]: { [key: string]: string }[];
}
export const fetchPuzzleData = async (
  formattedDate: string,
): Promise<{ [key: string]: string }[] | null> => {
  try {
    const response = await fetch("/feeds/puzzle");
    const puzzleData: PuzzleData = (await response.json()) as PuzzleData;
    let result = puzzleData[formattedDate] ?? null;

    // -- If there is no quiz for today, pick some random date's Quiz
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (result === null) {
      result = getRandomQuiz(puzzleData);
    }
    return result;
  } catch (error) {
    logger.error("Error fetching puzzle data:", { error });
    return null;
  }
};

export const getRandomQuiz = (
  puzzleData: PuzzleData,
): { [key: string]: string }[] => {
  try {
    const puzzleDates = Object.keys(puzzleData);
    // Retrieve the first and last date
    const firstDate = convertDateToISOFormat(puzzleDates[0]);
    const lastDate = convertDateToISOFormat(
      puzzleDates[puzzleDates.length - 1],
    );

    const start = new Date(firstDate);
    const end = new Date(lastDate);

    const randomDate = getRandomDate(start, end);
    const randomFormatDate = quizFormatDate(randomDate);

    const result = puzzleData[randomFormatDate];

    return result;
  } catch (error) {
    logger.error("Error fetching random puzzle data:", { error });
    return [];
  }
};
